/* eslint-disable boundaries/no-unknown */
import { Component, inject, OnInit } from '@angular/core';
import { ChildrenOutletContexts, RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNG } from 'primeng/config';
import { ButtonModule } from 'primeng/button';
import sr from './../../public/i18n/sr.json';
import en from './../../public/i18n/en.json';
import cyr from './../../public/i18n/cyr.json';

import {
  ENVIRONMENT,
  Environment,
} from 'libs/core/src/lib/config/environment-config';
import { sr as srPrimeng } from 'libs/core/src/lib/i18n/primeng-locale/sr';
import { en as enPrimeng } from 'libs/core/src/lib/i18n/primeng-locale/en';
import { cyr as cyrPrimeng } from 'libs/core/src/lib/i18n/primeng-locale/cyr';

import { CommonModule } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { LoadingToastComponent } from 'libs/ui/src/public-api';

@Component({
  selector: 'app-root',
  imports: [
    CommonModule,
    RouterOutlet,
    ButtonModule,
    ToastModule,
    LoadingToastComponent,
  ],
  template: `
    <router-outlet></router-outlet>

    <p-toast [life]="4500" position="bottom-right" key="br"></p-toast>
    <p-toast [life]="4500" position="bottom-right" key="br-warn"></p-toast>
    <p-toast [life]="4500" position="bottom-right" key="br-error"></p-toast>

    <lib-loading-toast></lib-loading-toast>
  `,
})
export class AppComponent implements OnInit {
  translate = inject(TranslateService);
  primeNG = inject(PrimeNG);
  contexts = inject(ChildrenOutletContexts);
  environment = inject<Environment>(ENVIRONMENT);

  primengLanguages: Record<string, any> = {
    en: enPrimeng,
    sr: srPrimeng,
    cyr: cyrPrimeng,
  };

  ngOnInit() {
    this.translate.setTranslation('sr', sr);
    this.translate.setTranslation('en', en);
    this.translate.setTranslation('cyr', cyr);
    this.translate.setFallbackLang('sr');
    let lang = localStorage.getItem(this.environment.STORAGE.language);
    if (!lang || !this.environment.SUPPORTED_LANGUAGES.includes(lang)) {
      lang = 'sr';
      localStorage.setItem(this.environment.STORAGE.language, 'sr');
    }
    this.translate.use(lang);
    this.primeNG.setTranslation(this.primengLanguages[lang]);
  }
}
